class CollapsibleContent {
  constructor() {
    this.accordionContainers = document.querySelectorAll('.js-accordions');
    this.detailsElements = [];

    this.accordionContainers.forEach(container => {
      const details = container.querySelectorAll('details');
      details.forEach(detail => this.detailsElements.push(detail));
    });

    this.init();
  }

  init() {
    this.detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (details.hasAttribute('open')) {
          this.animateClose(details, content);
        } else {
          const container = details.closest('.js-accordions');
          if (container) {
            const otherOpenDetails = container.querySelectorAll('details[open]');
            otherOpenDetails.forEach(openDetail => {
              if (openDetail !== details) {
                const openContent = openDetail.querySelector('.accordion__content');
                this.animateClose(openDetail, openContent);
              }
            });
          }

          this.animateOpen(details, content);
        }
      });
    });
  }

  animateOpen(details, content) {
    details.setAttribute('open', true);

    const height = content.offsetHeight;

    content.style.height = '0';
    content.style.overflow = 'hidden';
    content.style.transition = 'height 300ms ease-in-out';

    requestAnimationFrame(() => {
      content.style.height = `${height}px`;

      content.addEventListener('transitionend', () => {
        content.style.height = '';
        content.style.overflow = '';
        content.style.transition = '';
      }, { once: true });
    });
  }

  animateClose(details, content) {
    const height = content.offsetHeight;

    content.style.height = `${height}px`;
    content.style.overflow = 'hidden';
    content.style.transition = 'height 300ms ease-in-out';

    requestAnimationFrame(() => {
      content.style.height = '0';

      content.addEventListener('transitionend', () => {
        details.removeAttribute('open');
        content.style.height = '';
        content.style.overflow = '';
        content.style.transition = '';
      }, { once: true });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollapsibleContent();
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new CollapsibleContent();
  });
}
